import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import config from "../../config";

const testimonialSlice = createSlice({
  name: "testimonial",

  initialState: {
    testimonialData: [],
    isError: false,
  },

  reducers: {
    fetchTestimonialSuccess: (state, action) => {
      state.isError = false;
      state.testimonialData = action.payload;
    },
    fetchTestimonialFailure: (state) => {
      state.isError = true;
    },
  },
});

export const { fetchTestimonialSuccess, fetchTestimonialFailure } =
  testimonialSlice.actions;

export const fetchTestimonial = () => async (dispatch) => {
  try {
    const response = await axios.get(`${config.apiUrl}/home`);
    dispatch(fetchTestimonialSuccess(response.data.testimonial_list));
  } catch (error) {
    dispatch(fetchTestimonial());
  }
};

export default testimonialSlice.reducer;
